export default function FinalCTA() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Rooftop%20terrace%20at%20sunset%20with%20city%20skyline%20silhouette%20in%20background%2C%20outdoor%20wooden%20dining%20table%20with%20curated%20fashion%20accessories%20laid%20out%2C%20warm%20golden%20twilight%20glow%20with%20purple%20and%20orange%20sky%2C%20luxury%20lifestyle%20editorial%20photography%20with%20aspirational%20urban%20atmosphere%20and%20dramatic%20natural%20lighting&width=1600&height=900&seq=cta-bg-v3&orientation=landscape"
        alt="Pandabuy Spreadsheet start researching lifestyle"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="text-white text-3xl md:text-5xl font-extrabold leading-[1.1] tracking-tight mb-4">
              Start Researching Today
            </h2>
            <p className="text-white/80 text-base md:text-lg leading-relaxed">
              Join thousands of users using structured spreadsheets to find better products,
              compare deals, and optimize shipping decisions.
            </p>
          </div>

          <div className="flex-shrink-0">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center justify-between gap-3 px-7 py-4 rounded-full bg-white text-foreground-950 font-semibold text-base hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Access Spreadsheet Hub</span>
              <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}